import useIsRtl from "@/hooks/useIsRtl";
import React from "react";

const SvgRegisterArrow = () => {
  const isRtl = useIsRtl();
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={isRtl ? { transform: `rotate(180deg)` } : undefined}
    >
      <path
        d="M7.99214 3.19214C7.83299 3.19218 7.67747 3.23968 7.54546 3.32857C7.41345 3.41747 7.31096 3.54371 7.25107 3.69115C7.19118 3.8386 7.17663 4.00056 7.20928 4.15633C7.24192 4.31209 7.32027 4.45458 7.43432 4.56558L14.8687 12L7.43432 19.4343C7.35754 19.508 7.29624 19.5963 7.25402 19.694C7.21179 19.7917 7.18948 19.8969 7.1884 20.0033C7.18731 20.1098 7.20748 20.2153 7.24771 20.3139C7.28794 20.4124 7.34743 20.5019 7.42269 20.5772C7.49796 20.6525 7.58748 20.712 7.68602 20.7522C7.78456 20.7924 7.89014 20.8126 7.99658 20.8115C8.10301 20.8104 8.20816 20.7881 8.30586 20.7459C8.40356 20.7037 8.49186 20.6424 8.56557 20.5656L16.5656 12.5656C16.7155 12.4155 16.7998 12.2121 16.7998 12C16.7998 11.7878 16.7155 11.5844 16.5656 11.4343L8.56557 3.43433C8.49102 3.35769 8.40187 3.29677 8.30337 3.25518C8.20488 3.21358 8.09905 3.19214 7.99214 3.19214Z"
        className="fill-current"
      />
    </svg>
  );
};

export default SvgRegisterArrow;
